var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProteinIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_1403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.70176 11.6901C11.7746 9.65093 12.6677 6.21861 12.9205 4.6457C13.1565 4.6457 13.398 4.69064 13.6171 4.79176C14.8473 5.35351 15.8023 4.94343 16.982 4.52212C16.145 3.33682 14.5103 2.90988 14.5103 2.90988C14.5103 2.90988 14.7518 1.23024 13.9879 0C13.1396 0.926893 12.3925 1.64594 12.4318 2.99976C12.4318 3.17953 12.4093 3.35367 12.3588 3.5222C11.6847 3.25255 10.5387 2.88741 9.20172 2.73574C9.17925 2.73574 9.15678 2.75259 9.13431 2.75259C9.13431 2.75259 6.81427 2.79192 5.47168 3.85925C5.38742 3.92666 5.29192 3.95475 5.1908 3.95475C5.05598 3.95475 4.92678 3.89857 4.8369 3.7806C4.67961 3.58399 4.71331 3.29749 4.90993 3.14582C5.511 2.66833 6.2469 2.3706 6.93786 2.1796C6.29184 1.61223 6.03343 0.988686 5.85367 0.668487C4.76949 1.38753 3.0449 3.06156 2.44945 4.92096C-1.03343 8.24093 0.219283 12.6058 0.219283 12.6058C0.219283 12.6058 2.57865 13.5663 5.44921 13.0214L5.92108 12.9035C5.92108 12.9035 5.9267 12.8754 5.93232 12.8642C5.99411 12.6675 6.42104 11.2182 5.88176 9.97113C5.78064 9.74081 5.88738 9.47678 6.1177 9.37567C6.34802 9.28017 6.61204 9.38129 6.71315 9.6116C7.15694 10.6452 7.09515 11.8305 6.93786 12.6001C7.52208 12.3811 8.11754 12.0889 8.70738 11.6957L8.70176 11.6901ZM3.11231 10.2464C2.83144 10.4318 2.44945 10.3587 2.26407 10.0722C2.07869 9.79137 2.15172 9.40937 2.43821 9.22399C2.71909 9.03862 3.10108 9.11164 3.28646 9.39814C3.47184 9.67902 3.39881 10.061 3.11231 10.2464Z",
    fill: "url(#paint0_linear_481_1403)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0604 7.9713C18.3639 7.31967 15.8136 9.02178 14.8417 11.5553C13.8699 14.0888 14.8754 15.9314 16.7629 16.656C18.6504 17.3807 20.6053 16.6672 21.5772 14.1337C22.549 11.5946 21.7625 8.61732 20.0661 7.9713H20.0604ZM19.3919 9.51051C19.2964 9.57792 19.1841 9.60601 19.083 9.59477C18.847 9.64533 17.6449 9.97676 17.1112 11.3474C17.0438 11.5272 16.8697 11.6339 16.6899 11.6339C16.6337 11.6339 16.5776 11.6227 16.527 11.6002C16.2967 11.5104 16.1787 11.2463 16.2686 11.016C16.9764 9.21278 18.656 8.67911 19.1167 8.67911C19.1223 8.67911 19.1279 8.67911 19.1392 8.67911C19.3302 8.68473 19.5155 8.81955 19.5717 9.00493C19.6279 9.19031 19.5605 9.39254 19.4032 9.51051H19.3919Z",
    fill: "url(#paint1_linear_481_1403)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97138 14.4596C7.29736 15.1786 6.65696 18.1728 7.72991 20.6669C8.80286 23.1611 10.8083 23.7847 12.6621 22.987C14.5159 22.1893 15.4259 20.3186 14.353 17.8245C13.28 15.3303 10.6454 13.7405 8.97138 14.4596ZM9.55561 16.0325C9.53876 16.1448 9.47696 16.2403 9.3927 16.3077C9.25788 16.51 8.62871 17.5829 9.2017 18.9424C9.2972 19.1727 9.19047 19.4367 8.96015 19.5378C8.90397 19.5603 8.84218 19.5715 8.78601 19.5715C8.61186 19.5715 8.44334 19.4704 8.37031 19.2963C7.60632 17.4818 8.48266 15.9089 8.79724 15.6224C8.9433 15.4932 9.168 15.4595 9.33091 15.555C9.49943 15.6505 9.58931 15.8415 9.56123 16.0325H9.55561Z",
    fill: "url(#paint2_linear_481_1403)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_481_1403",
    x1: 8.49391,
    y1: 23.3128,
    x2: 8.49391,
    y2: 0.00561799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_481_1403",
    x1: 18.2347,
    y1: 0.00563879,
    x2: 18.2347,
    y2: 0.00563879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_481_1403",
    x1: 11.0049,
    y1: 0.00563969,
    x2: 11.0049,
    y2: 0.00563969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DC63F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_1403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProteinIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Protein_Icon.20b2439d.svg";
export { ForwardRef as ReactComponent };